import { PrismicError } from "./PrismicError.js";
class NotFoundError extends PrismicError {
}
export {
  NotFoundError
};
//# sourceMappingURL=NotFoundError.js.map
